import configs from './environment';
import API from '../helpers/api';
export default new API(configs['api']);
